import { apiClient } from './client';
import type { PaginatedResponse, PaginationParams, MessageResponse } from '../types/api';
import type { AdminUserListItem, AdminUserDetail, AdminUserUpdateRequest, AdminImpersonateRequest, AdminImpersonateResponse, AdminUserActivityItem, AdminSendEmailRequest, AdminBulkEmailRequest } from '../types/users';

export const usersApi = {
  list: (params: PaginationParams & { is_active?: boolean; plan?: string; email_verified?: boolean }) =>
    apiClient.get<PaginatedResponse<AdminUserListItem>>('/users', { params }).then((r) => r.data),
  detail: (id: string) =>
    apiClient.get<AdminUserDetail>(`/users/${id}`).then((r) => r.data),
  update: (id: string, data: AdminUserUpdateRequest) =>
    apiClient.patch<MessageResponse>(`/users/${id}`, data).then((r) => r.data),
  resetPassword: (id: string) =>
    apiClient.post<MessageResponse>(`/users/${id}/reset-password`).then((r) => r.data),
  verifyEmail: (id: string) =>
    apiClient.post<MessageResponse>(`/users/${id}/verify-email`).then((r) => r.data),
  deactivate: (id: string) =>
    apiClient.post<MessageResponse>(`/users/${id}/deactivate`).then((r) => r.data),
  reactivate: (id: string) =>
    apiClient.post<MessageResponse>(`/users/${id}/reactivate`).then((r) => r.data),
  deleteUser: (id: string) =>
    apiClient.delete<MessageResponse>(`/users/${id}`).then((r) => r.data),
  impersonate: (id: string, data: AdminImpersonateRequest) =>
    apiClient.post<AdminImpersonateResponse>(`/users/${id}/impersonate`, data).then((r) => r.data),
  sendEmail: (id: string, data: AdminSendEmailRequest) =>
    apiClient.post<MessageResponse>(`/users/${id}/send-email`, data).then((r) => r.data),
  activity: (id: string) =>
    apiClient.get<AdminUserActivityItem[]>(`/users/${id}/activity`).then((r) => r.data),
  bulkEmail: (data: AdminBulkEmailRequest) =>
    apiClient.post<MessageResponse>('/users/bulk-email', data).then((r) => r.data),
};
